import { render, staticRenderFns } from "./TextInformative.vue?vue&type=template&id=d1c42b10&scoped=true"
import script from "./TextInformative.vue?vue&type=script&lang=js"
export * from "./TextInformative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c42b10",
  null
  
)

export default component.exports